import type { Quaternion } from '@sb/geometry';

/**
 * Field-name projection from a geometry quaternion (`{i,j,k,w}`) to the
 * messenger wire quaternion (`{x,y,z,w}`). No math — same rotation, renamed
 * components.
 */
export const toMessengerQuaternion = (q: Quaternion) => ({
  x: q.i,
  y: q.j,
  z: q.k,
  w: q.w,
});
